import gql from 'graphql-tag'

export const ADD_BRAND = gql`
  mutation addBrand($parentUuid: ID!, $brand: BrandInput!, $type: SubbrandType!) {
    addBrand(parentUuid: $parentUuid, brand: $brand, type: $type) {
      id
      name
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations/AddBrand.tsx